
import { DropDownItem } from "@/models/Base/GlobalData";
import { GoalsList, PoiStatusGoal } from "@/models/MapPois/Quest/Goals";
import { QuestMapPoi } from "@/models/MapPois/Quest/QuestMapPoi";
import { toArray } from "lodash";
import { Component, Vue, Prop } from "vue-property-decorator";
import AlertBoxEditable from "../../../Base/AlertBoxEditable.vue";

@Component({
  components: { AlertBoxEditable },
})
class ActionPoiExit extends Vue {
  @Prop({ default: false }) readonly contentData!: GoalsList;
  @Prop({ default: false }) readonly isEditingLocked!: boolean;
  @Prop({ default: "" }) readonly mapPoiKey!: string;

  actionPoiExit: PoiStatusGoal = {
    req: {},
    parentID: "",
    status: "inactive",
  };
  updArray: any[] = [];

  get getUpdArray(): any[] {
    return this.updArray;
  }

  get getState(): DropDownItem[] {
    return [
      { text: "Found", value: 10 },
      { text: "Active", value: 20 },
      { text: "Complete", value: 30 },
    ];
  }

  created(): void {
    this.updArray = toArray(this.contentData.poiStatusGoal?.req);
  }

  get getMapPoiItems(): DropDownItem[] {
    if (this.contentData.poiStatusGoal !== undefined) {
      return this.$store.state.mapPoiStore.questMapPoi
        .filter((x: QuestMapPoi) => x.title.en !== "START_ZONE")
        .map((x: QuestMapPoi) => ({
          text: x.key == this.mapPoiKey ? x.title.en + " (self)" : x.title.en,
          value: x.key,
          disabled:
            this.getUpdArray.filter((y: any) => y.id == x.key).length > 0
              ? true
              : false,
        }));
    } else {
      return this.$store.state.mapPoiStore.questMapPoi
        .filter((x: QuestMapPoi) => x.title.en !== "START_ZONE")
        .map((x: QuestMapPoi) => ({
          text: x.title.en,
          value: x.key,
          disabled: false,
        }));
    }
  }

  cancel(): void {
    this.$emit("cancel");
  }

  AddNewItem(): void {
    if (!this.isEditingLocked) {
      this.getUpdArray.push({
        id: this.getMapPoiItems.filter(
          (x: DropDownItem) => x.disabled == false
        )[0].value,
        value: 10,
      });
    }
  }

  update(): void {
    this.getUpdArray.forEach((x) => {
      this.actionPoiExit.req[x.id] = {
        id: x.id,
        value: x.value,
      };
    });
    this.$emit("update", this.actionPoiExit);
  }
  removeItem(key: any): void {
    if (this.getUpdArray.length > 1) {
      delete this.actionPoiExit.req[this.getUpdArray[key].id];
      this.getUpdArray.splice(key, 1);
    } else {
      this.$bvModal.show("team-modal-alert-edit");
    }
  }

  openClearDialog(): void {
    this.$bvModal.show("team-modal-alert-edit");
  }

  alertOk(): void {
    this.actionPoiExit = {
      req: {},
      parentID: "",
      status: "",
    };
    this.$emit("deleteAction");
  }
}

export default ActionPoiExit;
